import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  display: true,
};

export const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    // Action to show the forms
    showForms: (state) => {
      state.display = true;
    },
    // Action to hide the forms
    hideForms: (state) => {
      state.display = false;
    },
    // Action to toggle the display of forms
    toggleForms: (state) => {
      state.display = !state.display;
    },
  },
});

export const {
  showForms,
  hideForms,
  toggleForms,
} = formsSlice.actions;

export default formsSlice.reducer;
